/*
 * Renderable fixture evidence. The live verifier serves artifact bytes from
 * /v1/runs/:id/artifacts/:artifactId; in fixture mode we ship committed SVG
 * captures for the demo failure so the evidence viewer is real, not a
 * placeholder. Annotations are declared in percentages of the capture frame.
 */

export interface EvidenceAnnotation {
  left: string
  top: string
  width: string
  height: string
  label: string
}

export interface EvidenceImage {
  url: string
  annotation?: EvidenceAnnotation
}

export const fixtureArtifactImages: Record<string, EvidenceImage> = {
  'artifact-failure': {
    url: '/fixtures/confirm-project-failure.svg',
    annotation: {
      left: '18.4%',
      top: '16.2%',
      width: '13%',
      height: '7.4%',
      label: 'Heading still reads “Blume” — expected “Atlas”'
    }
  },
  'artifact-diff': { url: '/fixtures/confirm-project-diff.svg' },
  'artifact-baseline': { url: '/fixtures/confirm-project-baseline.svg' },
  'artifact-before': { url: '/fixtures/open-project-switcher-before.svg' },
  // Live-run fixtures: captures streamed while the agent explores/stabilizes.
  'artifact-explore-switcher': { url: '/fixtures/open-project-switcher-before.svg' },
  'artifact-stab-switcher': { url: '/fixtures/open-project-switcher-before.svg' }
}

export interface EvidenceVideo {
  url: string
  poster?: string
  /** Seconds into the recording where the failing assertion happens. */
  failingMomentSeconds?: number
}

/**
 * Renderable fixture recordings, keyed by artifact id like the images. The
 * live verifier serves the same bytes from the artifact endpoint.
 */
export const fixtureArtifactVideos: Record<string, EvidenceVideo> = {
  'artifact-recording': {
    url: '/fixtures/attempt-2-recording.webm',
    poster: '/fixtures/attempt-2-recording-poster.png',
    failingMomentSeconds: 4
  }
}

/** Short comparison labels for the screenshot kinds shown in the stream. */
export const screenshotKindShortLabel: Record<string, string> = {
  'screenshot-failure': 'Failure',
  'screenshot-diff': 'Diff',
  'screenshot-baseline': 'Baseline',
  'screenshot-before': 'Before',
  'screenshot-after': 'After'
}
